import { Button, Form, Input, Space, } from "antd";
import { useEffect, useState } from "react";

const SchemaConfiguration = ({show, client, onBack, onNext, onClose}: any) => {

    const [schemaSource, setSchemaSource] = useState<string>('API');
    
    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue(client);
    }, [client]);

    const requiredRule = (isRequired: boolean, message: string) => {
        return {
          required: isRequired,
          message: message,
        }
    }

    const onFinish = (values: any) => {
        const data = {...client, ...values, schemaSource};
        onNext(data);
    }

    return <Form 
        form={form}
        className="clients-page-form"
        onFinish={onFinish}
        style={{overflow: 'hidden', height: show ? 'auto' : '0rem'}}
        >
  
        <h2>Schema Configuration</h2>

        <h3>Schema Source</h3>
        
        <h3>Source Reference</h3>
        <label>Paste the source reference here</label>
        <Form.Item
            name="sourceData"
            rules={[
                requiredRule(false, "Source reference is required.")
            ]}
        >
            <Input.TextArea style={{height: '24rem'}}  />
        </Form.Item>
        
        <Space direction="horizontal" align="end" style={{marginTop: '2rem', width: '100%', justifyContent: 'flex-end'}}>
            <Button type="default" key="cancel" onClick={onClose}>Cancel</Button>
            <Button type="primary" onClick={onBack}>Back</Button>
            <Button type="primary" htmlType="submit">Proceed</Button>
        </Space>
    </Form>
}

export default SchemaConfiguration;